<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border w-full my-0 mx-auto">
      <div class="flex flex-row m-2 sm:m-4 text-base sm:text-lg gap-2 items-center flex-wrap">
        <span class="break-words">{{ $t('KssTrackerComponent.showArchivedTask', { text: featureName }) }}</span>
        <ToggleSwitch class="relative inline-block toggle-width shrink-0" v-model="displayArchivedTasks"/>
      </div>
      <div class="mx-2 sm:mx-4 mb-4">
        <IconField>
          <InputIcon class="pi pi-search" />
          <InputText v-model="searchbar" :placeholder="$t('KssTrackerComponent.placeholder')"
              class="w-full text-sm sm:text-base"/>
        </IconField>
      </div>
      <div class="relative mx-2 sm:mx-4" id="task_card_container">
        <template v-if="createdTasks && createdTasks.length > 0">
          <kss-task-created-component v-for="task in filterCreatedTasks" :createdTask="task"
                                      :key="task._id" :allKssParticipants="allKssParticipants"
                                      :involvedKssUsers="involvedKssUsers"/>
        </template>
        <div v-else class="py-6 text-center items-center">
          <h2 class="text-gray-700 mb-2 text-lg sm:text-xl">
            {{ $t('KssTrackerComponent.noCollaborationTrackers', { text: featureName }) }}
          </h2>
          <p class="text-gray-500 text-sm sm:text-base">
            {{ $t('KssTrackerComponent.noCollaborationTrackersMessage', { text: featureName }) }}
          </p>
        </div>
      </div>
      <div v-if="displayArchivedTasks" class="relative mx-2 sm:mx-4 mt-4" id="task_card_container_archiv">
        <kss-task-archived-component v-for="task in filterArchivedTasks" :archivedTask="task"
                                     :key="task._id"/>
      </div>
    </div>
  </div>
  <provide-feedback-component />
</template>

<script>
import KssTaskCreatedComponent from '@/components/Home/KssCreator/KssTaskCreatedComponent.vue';
import KssTaskArchivedComponent from '@/components/Home/KssCreator/KssTaskArchivedComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';
import {
  IconField,
  InputIcon,
  InputText,
  ToggleSwitch,
} from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'KssTrackerComponent',
  props: {
    tab: {
      type: String,
      default: 'alreadyCreated',
    },
  },
  components: {
    KssTaskArchivedComponent,
    KssTaskCreatedComponent,
    ProvideFeedbackComponent,
    ToggleSwitch,
    IconField,
    InputIcon,
    InputText,
  },
  data() {
    return {
      displayArchivedTasks: false,
      searchbar: '',
    };
  },
  watch: {
    checked() {
      this.$emit('input', this.displayArchivedTasks);
    },
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
    createdTasks() {
      return this.$store.getters.getCurrentCreatedTasks;
    },
    allKssParticipants() {
      return this.$store.getters.getKssParticipants;
    },
    involvedKssUsers() {
      return this.$store.getters.getInvolvedKssUsers;
    },
    archivedTasks() {
      return this.$store.getters.getCurrentArchivedTasks;
    },
    filterCreatedTasks() {
      return this.createdTasks.filter((el) => el.name.toLowerCase()
        .includes(this.searchbar.toLowerCase())
      || el.description.toLowerCase().includes(this.searchbar.toLowerCase())).toSorted();
    },
    filterArchivedTasks() {
      return this.archivedTasks.filter((el) => el.name?.toLowerCase()
        .includes(this.searchbar?.toLowerCase())
      || el.description?.toLowerCase().includes(this.searchbar?.toLowerCase())).toSorted();
    },
  },
  methods: {
    onToggleArchivedTasks() {
      this.displayArchivedTasks = !this.displayArchivedTasks;
      this.$emit('input', this.displayArchivedTasks);
    },
  },
  mounted() {
    this.$store.dispatch('getArchivedTasks');
    this.$store.dispatch('getCreatedTasks');
    this.$store.dispatch('getTeams');
    // pass the logged in user to select him by default
    this.$store.dispatch('getKssParticipants', this.$store.getters.getUser?.name);
  },
  unmounted() {
    this.$store.commit('removeArchivedTasks');
    this.$store.commit('removeCreatedTasks');
  },
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
  .toggle-width {
    width: 3.25rem !important;
  }
}
</style>
